import React from 'react';
import {Box,Button} from '@mui/material';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as ETVConstants from '../ETVConstants';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVPopup from '../tools/ETVPopup';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { buildingApi } from '../building/BuildingApi';

class SelectDevice extends React.Component {

	constructor(props) {
      super(props);
      this.selectedScreens = this.selectedScreens.bind(this);
      this.closeScreenSelection = this.closeScreenSelection.bind(this);
    }

    state = {
      	devices:[],
		groups:[],
		select_group_devices:[], //object of devices with groups
      	result_json: undefined,
      	selectedDevice:"all_devices",
      	layoutUrl: '',
      	isLandscape: true,
		screenRatio:16.0/9.0,
      	isLoaded: false,
		isLoading:false,
      	selected_screens:[],
      	info_message_title: undefined,
      	info_message: undefined,
		group_is_selected:false,
		device_is_selected:false
    }

	getGroupName( deviceID, groups) {
		for(var i=0; i<groups.length; i++) {
			if(groups[i]["device_ids"].includes(deviceID)) return groups[i].group_name;
		}
		return "-- no group --";
	}

	createGroupDevices(devices,groups) {
		var result = [];
		for(var i=0; i<groups.length; i++) {
			var obj = {};
			obj["id"]="_group_"+groups[i].group_id;
			obj["device_name"]=groups[i].group_name;
			obj["group_name"]="groups";
			result.push(obj);
		}
		for(var j=0; j<devices.length; j++) {
			var obj2 = {};
			obj2["id"]=devices[j].id;
			obj2["device_name"]=devices[j].device_name;
			obj2["group_name"]="devices";
			obj2["last_connected"]=devices[j].last_connected;
			obj2["startup_datetime"]=devices[j].startup_datetime;
			obj2["status"]=devices[j].status;
			result.push(obj2);
		}
		//result.sort( (a, b) => a.group_name >= b.group_name ? -1 : 1);
		result.sort( this.sortDeviceGroupList);
		return result;
	}

	sortDeviceGroupList( a, b) {
		//both groups
		if(a.id.startsWith("_group_") && b.id.startsWith("_group_")) {
			return a.group_name.localeCompare(b.group_name);
		}else if(a.id.startsWith("_group_")) {
			return -1;
		}else if(b.id.startsWith("_group_")) {
			return 1;
		}else{
				return (a.device_name.localeCompare(b.device_name));
		}
	}

    componentDidMount() {
      this.loadData();
    }

	handleDeviceChangeNew = (e,value) => {
		if(!value) return;
		var selectedDevice = value.id;
		this.setState({selectedDevice:selectedDevice});
      	if(selectedDevice==="all_devices") {
          	this.setState({selectedDevice:"all_devices",layoutUrl:undefined});
			this.props.layoutSelectedF( null,-1, null);
			return;
      	}
		//can be from group or device
		var groupID = this.getGroupID(selectedDevice);
		if(groupID>=0) {
			//is a group
			var commonLayoutID = this.getCommonLayoutID(groupID);
			this.props.layoutSelectedF( null ,groupID, commonLayoutID);
			this.setState({group_is_selected:true,device_is_selected:false});
		}else{
			var device = this.getDevice(selectedDevice);
			if(Number(device.device_type)===3) {
				this.props.layoutSelectedF(device,-1,'web-player-fullscreen');
				this.setState({group_is_selected:false,device_is_selected:true,layoutUrl:undefined,screenRatio:16.0/9.0});
				return;
			}
			this.loadLayout(value.id);
			var screenRatio = 16.0/9.0;
			try{
				screenRatio = parseFloat(device.screen_ratio);
			}catch(e) {
				//console.log("could not parse float: "+device.screen_ratio);
			}
			//console.log("---->device selected screenrRatio: "+screenRatio);
	      	this.props.layoutSelectedF( device,-1, device.layout_id);
			this.setState({group_is_selected:false,device_is_selected:true,screenRatio:screenRatio});
		}
	}

    getDevice( deviceID) {
      	for( var i=0; i<this.state.devices.length; i++) {
        	if(this.state.devices[i].id===deviceID) {
          		return this.state.devices[i];
        	}
      	}
      	return "all_devices";
    }

	getGroup( groupID) {
		for(var i=0; i<this.state.groups.length; i++) {
			if(this.state.groups[i].group_id===groupID) {
				return this.state.groups[i];
			}
		}
		return null;
	}

	getCommonLayoutID(groupID) {
		var group = this.getGroup(groupID);
		var deviceIDs = group.device_ids;
		var commonLayout = -1;
		for(var i=0; i<deviceIDs.length; i++) {
			var d = this.getDevice(deviceIDs[i]);
			if(commonLayout<0) {
					commonLayout = d.layout_id;
			}else{
					if(d.layout_id!==commonLayout) return null;
			}
		}
		return commonLayout;
	}

	getGroupID( groupStr) {
		if(groupStr.indexOf("_group_")!==0) {
			return -1;
		}
		return parseInt(groupStr.substring("_group_".length));
	}

    loadLayout( selectedDeviceID) {
		if(selectedDeviceID==="all_devices") {
			return;
		}
		var layoutID = '';
		var groupID = this.getGroupID(selectedDeviceID);
		if(groupID>=0) {
			//group is selected
			layoutID = this.getCommonLayoutID(groupID);
			if(layoutID===null) {
				this.showInfoMessage(ETVConstants.trans("error"),ETVConstants.trans('error_group_has_no_common_layout'));
			}
		}else{
			//device is selected
			var dev = this.getDevice(selectedDeviceID);
			layoutID = dev.layout_id;
		}
		var accessToken = localStorage.getItem("etv.access_token");
      	var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/layout_mgmt?action=get_layout&layout_id="+layoutID;
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then(res => res.json())
			.then(
			(result) => {
				this.setState({
				layoutUrl: result.thumbnail,
				isLandscape: result.landscape,
				});
			},
			(error) => {
				this.setState({
				layoutUrl: undefined,
				error
				});
			}
			)
    }

    async loadData() {
		this.setState({isLoading:true});
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/device_mgmt?action=list&owner_id="+this.props.user_id;
		try {
			const [legacyResult, webResult] = await Promise.allSettled([
				fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }}).then(res=>res.json()),
				ETVConstants.ON_PREMISE_VERSION
					? Promise.resolve({list:[]})
					: buildingApi('admin_list_web_players',{query:{owner_user_id:this.props.user_id}}),
			]);
			if(legacyResult.status!=='fulfilled') throw legacyResult.reason;
			const result = legacyResult.value || {};
			const groups = ETVConstants.filterOutEmptyGroups(result.groups || []);
			const byID = new Map((result.list || []).map(device=>[device.id,device]));
			if(webResult.status==='fulfilled') {
				(webResult.value.list || []).forEach(device=>byID.set(device.id,{...(byID.get(device.id) || {}),...device}));
			}
			const devices = Array.from(byID.values());
			this.setState({
				isLoaded:true,isLoading:false,result_json:result,devices,groups,
				select_group_devices:this.createGroupDevices(devices,groups)
			});
		}catch(error) {
			this.setState({isLoaded:false,isLoading:false,error});
		}
    }

    showWindow(divID, show) {
		show?this.setState({window:divID}):this.setState({window:''});
	}

    showCopyPlaylist() {
      this.showWindow('copy_playlist_div',true);
    }

    // hook function
    selectedScreens(screenIDs) {
      this.showWindow('copy_playlist_div',false);
      this.setState({selected_screens:screenIDs});
      this.submitCopyPasteScreens(screenIDs);
    }

    submitCopyPasteScreens(screenIDs) {
		this.showInfoMessage(ETVConstants.trans("copy") || "Copy", ETVConstants.trans("copying_settings") || "Copying settings...");
		var url = ETVConstants.getServerBase()+"/playlist?action=copy_playlist&from_device="+this.state.selectedDevice;
		for(var i=0; i<screenIDs.length; i++) {
			url += "&to_device="+screenIDs[i];
		}
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		//console.log("url="+url);
	    fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(async (res) => {
			const result = await res.json();
			if(!res.ok || result.result===false) {
				throw new Error(result.reason || `Request failed (${res.status})`);
			}
			return result;
		})
		.then(() => {
			this.showInfoMessage(ETVConstants.trans("success"),ETVConstants.trans("playlist_copied_to_selected_devices"));
		})
		.catch((error) => {
			this.showInfoMessage(ETVConstants.trans("error"),error.message || String(error));
		});
    }

    closeScreenSelection() {
      	this.showWindow('copy_playlist_div',false);
    }

    showInfoMessage(title,text) {
      	this.setState({info_message_title:title,info_message:text});
      	this.showWindow('message_div',true);
    }

    closeInfoMessage() {
      	this.setState({info_message:undefined});
      	this.showWindow('message_div',false);
    }

	//calculates the best image width depending on layout
	getOptimalLayoutWidth( isLandscape, screenRatio) {
		if(isLandscape) {
			return 250*screenRatio;
		}else{
			return 250;
		}
	}

	getOptimalLayoutHeight( isLandscape, screenRatio) {
		if(isLandscape) {
			return 250;
		}else{
			return 250*screenRatio;
		}
	}

    render() {
      return(
		<Box>
			<Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'minmax(280px, 340px) minmax(0, 1fr)'},gap:3,alignItems:'start'}}>
				<Box>
										<Autocomplete
											id="select screen"
											options={this.state.select_group_devices}
											groupBy={(option) => option.group_name}
											getOptionLabel={(option) => option.device_name}
											sx={{width:'100%'}}
											loading={this.state.isLoading}
											onChange={this.handleDeviceChangeNew}
											renderOption={(props, option) => (
												<Box component="li" {...props} sx={{display:'flex',alignItems:'center',gap:1}}>
													{option.group_name==='devices' ? (
														<Box sx={{width:18,display:'inline-flex',alignItems:'center',justifyContent:'center','& svg':{fontSize:14}}}>
															{option.last_connected
																? ETVConstants.getLastConnectSymbol(option.last_connected,option.startup_datetime,option.status)
																: <Box component="span" title={ETVConstants.trans('playlist_status_unavailable')} sx={{width:12,height:12,borderRadius:'50%',bgcolor:'#fa2d33'}}/>}
														</Box>
													) : null}
													<Box component="span" sx={{overflow:'hidden',textOverflow:'ellipsis'}}>{option.device_name}</Box>
												</Box>
											)}
											renderInput={(params) => <TextField {...params} label="select device" variant="outlined" />}
										/>
					{(this.state.device_is_selected && this.props.can_copy)?<Button sx={{mt:2}} startIcon={<ContentCopyIcon/>} disabled={this.state.selectedDevice==='all_devices' || !this.props.can_copy} variant='contained' color="primary" onClick={() => this.showCopyPlaylist()}>{ETVConstants.trans("copy_playlist_and_layout")}</Button>:<span/>}
				</Box>
				<Box sx={{display:'flex',justifyContent:'center',minHeight:120,bgcolor:'action.hover',borderRadius:2,p:2}}>
										{
											this.state.layoutUrl?
													<img key={"layout_img"} alt='layout' src={ETVConstants.ON_PREMISE_VERSION?ETVConstants.makeLayoutURLRelative(this.state.layoutUrl):this.state.layoutUrl} style={{maxWidth:'100%',maxHeight:260,objectFit:'contain'}} />
												:
												<span/>
										}
				</Box>
			</Box>

			<ETVPopup
				open={this.state.window==='copy_playlist_div'}
				onClose={()=>{this.setState({window:''})}}
				width="small"
				icon={<ContentCopyIcon/>}
				title={ETVConstants.trans("copy_playlist_and_layout")}
				bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.closeScreenSelection()}/>}
			>
						<SelectAvailableScreensNew isOpen={this.state.window==='copy_playlist_div'} user_id={this.props.user_id} closeHook={this.closeScreenSelection} excluded_screen_ids={[this.state.selectedDevice]} selectedScreens={this.selectedScreens} selected={this.state.selected_screens?this.state.selected_screens:[]}/>
			</ETVPopup>

			<ETVMessagePopup open={this.state.window==='message_div'} onClose={()=>this.closeInfoMessage()} title={this.state.info_message_title} message={this.state.info_message}/>

		</Box>
		);
	}
}

export default SelectDevice
